import { Menu } from '@looker/components';
import { type FC, useEffect } from 'react';
import { useLookerDashboardContext } from '../../../../../providers/LookerDashboardProvider';
import { type ProviderType, useAdvancedFilters } from '../../hooks/useAdvancedFilters';

import AndOrMenu from '../AndOrMenu';
import { ConditionCard } from '../ConditionCard';
import { StyledAddButton, StyledAddIcon, StyledParagraph } from './styles';

const AdvancedFilters: FC<{
  context: ProviderType;
  displayHintText?: boolean;
}> = ({ context, displayHintText = true }) => {
  const { groups, addGroup, clearAllGroups, setRelationshipBetweenGroups } = useAdvancedFilters(context);
  const { resetTriggered } = useLookerDashboardContext();

  useEffect(() => {
    if (resetTriggered) {
      clearAllGroups();
    }
  }, [resetTriggered]);

  const handleAddEmptyGroup = () => {
    addGroup();
    setRelationshipBetweenGroups('AND');
  };

  return (
    <>
      {!groups?.[0]?.conditions?.length ? (
        displayHintText ? (
          <StyledParagraph>
            Advanced filter allows to combine conditions using AND and OR logic. Advanced filter will be added on top of
            selected regular filters.
          </StyledParagraph>
        ) : null
      ) : (
        <ConditionCard context={context} />
      )}

      {groups?.[0]?.conditions?.length >= 1 ? (
        <StyledAddButton color="invisible" iconBefore={<StyledAddIcon icon="Add" />} onClick={handleAddEmptyGroup}>
          Add Group
        </StyledAddButton>
      ) : (
        // @ts-expect-error ts(2739)
        <Menu content={<AndOrMenu groupID={0} context={context} />} placement="right-start">
          <StyledAddButton color="invisible" iconBefore={<StyledAddIcon icon="Add" />}>
            Add Condition
          </StyledAddButton>
        </Menu>
      )}
    </>
  );
};

export default AdvancedFilters;
